// components/layouts/DashboardLayout.jsx
import { Box, Flex } from "@chakra-ui/react";
import DashboardBlade from "components/DashboardBlade";
import GlobalHeader from "components/DashboardBlade/GlobalHeader";

import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

export default function DashboardLayout({ sidebarCollapsed = false }) {
  const [collapsed, setCollapsed] = useState(sidebarCollapsed);

  useEffect(() => setCollapsed(sidebarCollapsed), [sidebarCollapsed]);
  const handleToggle = () => setCollapsed((p) => !p);

  return (
    <Flex h="100vh" overflow="hidden">
      <Box flexShrink={0}>
        <DashboardBlade collapsed={collapsed} onToggle={handleToggle} />
      </Box>

      <Flex flex="1" direction="column" overflow="hidden">
        {/* <GlobalHeader collapsed={collapsed} /> */}
        <Box flex="1" overflowY="auto" bg="gray.50">
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
}
